import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "../../../../assets/icons/edit-icon.svg";
import ArchiveIcon from "../../../../assets/icons/archive-icon.svg";
import statusIcon from "../../../../assets/icons/status.svg";
import duplicateIcon from "../../../../assets/icons/duplicate-icon.svg";
import assignPartnerIcon from "../../../../assets/icons/user-add-icon.svg";

type Props = {
  row: any;
  handleEdit: any;
  handleDuplicate: any;
  setArchive: any;
  setAssignPartner: any;
  handleStatusToggle: any;
};

const CustomActionsDropdown: React.FC<Props> = ({
  row,
  handleEdit,
  handleDuplicate,
  setArchive,
  setAssignPartner,
  handleStatusToggle,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleArchive = () => {
    handleClose();
    if (setArchive) {
      setArchive(row.id, row.planName, row.assignedPartnerLength);
    }
  };

  const handleAssignPartner = () => {
    handleClose();
    if (setAssignPartner) {
      setAssignPartner();
    }
  };

  const handleStatus = () => {
    handleClose();
    if (handleStatusToggle) {
      handleStatusToggle(
        row.id,
        row.status === "Active" ? false : true,
        row.planName
      );
    }
  };

  return (
    <>
      <IconButton onClick={handleOpen} size="small" title="">
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: 2,
            minWidth: 160,
          },
        }}
      >
        <MenuItem onClick={handleEdit} disabled={row.assignedPartnerLength > 1}>
          <ListItemIcon>
            <img src={EditIcon} alt="Edit Icon" />
          </ListItemIcon>
          <ListItemText primary="Edit" />
        </MenuItem>
        <MenuItem onClick={handleDuplicate}>
          <ListItemIcon>
            <img src={duplicateIcon} alt="Duplicate Icon" />
          </ListItemIcon>
          <ListItemText primary="Duplicate" />
        </MenuItem>
        <MenuItem
          onClick={handleArchive}
          disabled={row.assignedPartnerLength > 0}
        >
          <ListItemIcon>
            <img src={ArchiveIcon} alt="Archive Icon" />
          </ListItemIcon>
          <ListItemText primary="Archive" />
        </MenuItem>
        <MenuItem
          onClick={handleAssignPartner}
          disabled={row.status === "Inactive"}
        >
          <ListItemIcon>
            <img src={assignPartnerIcon} alt="Assign Partner Icon" />
          </ListItemIcon>
          <ListItemText primary="Assign Partner" />
        </MenuItem>
        <MenuItem onClick={handleStatus}>
          <ListItemIcon>
            <img src={statusIcon} alt="Inactive plan Icon" />
          </ListItemIcon>
          <ListItemText
            className={
              row.status === "Active" ? "status-inactive" : "status-active"
            }
            primary={`${row.status === "Active" ? "Inactive Plan" : "Active Plan"}`}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default CustomActionsDropdown;
